import React, { Component } from 'react';
import {Text, Group, Transformer, Ellipse, Image} from 'react-konva';
import DeleteButton from "../Shapes/deleteButton";

class TextSolo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      padding: 14,
      width: null,
      height: null,
      posx: 0,
      posy: 0,
    }
  }

  componentDidMount() {
    const text = this.transform.parent.findOne(`.${this.props.name}`);
/*    this.setState({
      padding: (this.props.height - text.getTextHeight())/1.5,
    }); */
    this.transform.attachTo(text);
    this.transform.rotateEnabled(false);
    this.transform.borderEnabled(false);
    this.transform.forceUpdate();
    this.transform.getLayer().draw();
  }

  shouldComponentUpdate(nextProps) {
    let props  = Object.assign({}, this.props);
    let is = true;
    for (let key in props) {
      if (props[key] === nextProps[key]) {
        is = is && true
      } else {
        is = false;
      }
    }
    if (is) {
      return false;
    }
    return true;
  }

  componentDidUpdate() {
    const text = this.transform.parent.findOne(`.${this.props.name}`);
    if (this.transform.rotateEnabled() === true) {
      this.transform.rotateEnabled(true);
    } else {
      this.transform.rotateEnabled(false);
    }
    this.transform.attachTo(text);
    this.transform.forceUpdate();
    if (this.transform.getLayer() !== null) {
      this.transform.getLayer().draw();
    }
  }

  onMouseOver = () => {
    document.body.style.cursor = 'pointer';
  }

  onMouseOut = () => {
    document.body.style.cursor = 'default';
  }

  onMouseDown = () => {
    document.body.style.cursor = 'grabbing';
  }

  onMouseUp = () => {
    document.body.style.cursor = 'grab';
  }
  handleClick = (e) => {
    this.setState({
      dbVisible: true
    })
  }



  setDeleteButtonPosition = (target) => {
    this.setState({
      posx: target.attrs.x,
      posy: target.attrs.y,
    })
    // this.transform.parent.children[2].forceUpdate()
    this.forceUpdate();
  }

  setTextStyle = (prop) => {
    let styles = {
      textDecoration: "normal",
      fontStyle: "normal"
    };
    this.props.underline ? styles.textDecoration = "underline" : styles.textDecoration = "normal";
    this.props.italic && this.props.bold ?
        styles.fontStyle = "bold italic" :
      this.props.italic ?
        styles.fontStyle = "italic" :
        this.props.bold ?
          styles.fontStyle = "bold" :
          styles.fontStyle = "normal";
    return styles[prop];
  }

  render() {
    return (
      <Group
        draggable
        x={this.props.x}
        y={this.props.y}
        onDragEnd={(e) => this.props.setTextInitialPosition(e.target.x(), e.target.y(), this.props.i, this)}
      >
        <Text
          name={this.props.name}
          text={this.props.value}
          fontSize={this.props.size}
          fontFamily={this.props.family}
          textDecoration={this.setTextStyle('textDecoration')}
          fontStyle={this.setTextStyle('fontStyle')}
          fill={this.props.color}
          padding = {this.state.padding}
          align={"center"}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          onMouseDown={this.onMouseDown}
          onMouseUp={this.onMouseUp}
          onClick={e => this.handleClick(e)}
          id={this.props.i}
          onTransform={(e) => this.setDeleteButtonPosition(e.currentTarget)}
        />
        <Transformer
          ref={node => {
            this.transform = node;
          }}
          name={`newTexts-tranformer`}
          resizeEnabled={false}
          rotateAnchorOffset={window.innerWidth > 1120 ? 20 : 40}
          anchorSize={window.innerWidth > 1120 ? 12 : 25}
          anchorStroke={'white'}
          anchorFill={'white'}
          borderStroke = {'white'}
          borderStrokeWidth = {2}
          borderDash = {[5,2]}
        />
        <DeleteButton
          posx={this.state.posx}
          posy={this.state.posy}
          deleteElement={this.props.deleteElement}
          parent={this}
          visible={false}
          name='deleteButton'
          className = "deleteButton"
        />
      </Group>
    );
  }
}

export default TextSolo;



// WEBPACK FOOTER //
// ./src/components/TextGroup/TextSolo.js